import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchEvent(app, params) {
  const { id } = params;
  const docType = DocType.EVENT;
  return common.getDoc(app, { id, docType });
}

export function deleteEvent(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.EVENT
  });
}

export function saveEvent(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const { recurrence_pattern } = data;
  const {
    time,
    day,
    month,
    day_of_week,
    timezone,
  } = recurrence_pattern || {};

  const doc = {
    active: util.toBoolean(data.active),
    description: util.toStringText(data.description),
    doc_type: DocType.EVENT,
    interval_count: data.interval_count,
    interval: util.toStringText(data.interval),
    name: util.toStringText(data.name),
    process: data.process,
    schedule_pattern: data.schedule_pattern,
    schedule_type: util.toStringText(data.schedule_type),
    trigger: data.trigger,
    type: util.toStringText(data.type),
    workflows: data.workflows,
    meta_lines: data.meta_lines,
    end_date: util.toStringDate(data.end_date),
    recurrence_pattern: {
      time: util.toStringText(time),
      day: util.toInteger(day),
      month: util.toInteger(month),
      day_of_week: util.toInteger(day_of_week),
      timezone: util.toStringText(timezone),
    },
  };

  return common.saveDoc(app, {
    doc,
    user,
    source: data,
  });
}

export async function getEventLogs(app, filters) {
  const newFilters = common.parseFilters(filters || {});
  const service = app.service(`event/${filters.event_id}/logs`);
  const resData = await service.find({ query: newFilters });
  
  const data = {
    data: resData.rows,
    total: resData.count,
    limit: newFilters.limit,
    skip: newFilters.skip,
  };

  return data;
}
